import Image from "next/image";

export default function ClientStoryCard({
  companyName,
  summary,
  logoUrl,
}: {
  companyName: string;
  summary: string;
  logoUrl: string;
}) {
  return (
    <div className="relative flex h-125 w-full flex-col justify-end md:h-120 p-3">
      <Image
        width={180}
        height={180}
        src={logoUrl}
        alt={`${companyName} logo`}
        className="absolute top-12 z-9 ml-8 aspect-square h-45 w-45 rounded-2xl bg-white object-contain p-2 blur-lg"
        sizes="180px"
      />
      <Image
        width={180}
        height={180}
        src={logoUrl}
        alt={`${companyName} logo`}
        className="absolute top-8 z-10 ml-8 aspect-square h-45 w-45 rounded-2xl bg-white object-contain p-2 shadow-sm"
        sizes="180px"
      />
      <div className="border-accent-light relative flex h-80 w-full flex-col justify-between rounded-3xl border-6 px-10 pt-16 pb-4 md:h-80 lg:pt-24">
        <p className="line-clamp-6 text-xl leading-relaxed first-letter:text-3xl">
          {summary}
        </p>
        <p className="mt-6 text-right text-xl font-semibold">{companyName}</p>
        <Image
          src="/icons/quote.svg"
          alt="quote icon"
          width={100}
          height={80}
          className="absolute bottom-6 left-6 h-auto w-25"
        />
      </div>
    </div>
  );
}
